/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Team • 50+ membri',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Team • 50+ membri, te compreso',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Team • 1 membro} other {Team • {0} membri}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Team • 1 membro, te compreso} other {Team • {0} membri, te compreso}}',
  'fabric.elements.mentions.xproduct.mention.description': "Necessita dell'accesso a Confluence",
  'fabric.mention.error.defaultAction': 'Riprova tra qualche secondo',
  'fabric.mention.error.defaultHeadline': 'Si è verificato un errore',
  'fabric.mention.error.differentText': 'Prova a inserire un testo diverso',
  'fabric.mention.error.loginAgain': 'Prova a uscire e ad accedere di nuovo',
  'fabric.mention.noAccess.label': 'Nessun accesso',
  'fabric.mention.noAccess.warning': 'A {name} non verrà inviata una notifica poiché non ha accesso',
  'fabric.mention.unknow.user.error': 'Utente {userId} sconosciuto'
};